// extracted by mini-css-extract-plugin
export default {"defaultUi":"default-ui--B3CWq6RV_s22nY5gTUGR"};